import { lazy } from 'react';

export const DepositAsync = lazy(() => import(/* webpackChunkName: "user-deposit" */ 'components/user/psp/deposit'));

export const WithdrawalAsync = lazy(
  () => import(/* webpackChunkName: "user-withdrawal" */ 'components/user/psp/withdrawal'),
);
export const TransferAsync = lazy(() =>
  // eslint-disable-next-line promise/prefer-await-to-then
  import(/* webpackChunkName: "user-transfer" */ 'components/user/psp/Transfer').then((m) => ({ default: m.Transfer })),
);
export const EWalletAsync = lazy(() =>
  // eslint-disable-next-line promise/prefer-await-to-then
  import(/* webpackChunkName: "user-eWallet" */ 'components/user/psp/eWallet').then((m) => ({ default: m.EWallet })),
);
export const BankAccountRoutersAsync = lazy(() =>
  // eslint-disable-next-line promise/prefer-await-to-then
  import(/* webpackChunkName: "user-bankAccountDetails" */ 'components/user/psp/BankAccount').then((m) => ({
    default: m.BankAccountRouters,
  })),
);
export const CryptoWalletDetailsRoutersAsync = lazy(() =>
  // eslint-disable-next-line promise/prefer-await-to-then
  import(/* webpackChunkName: "user-cryptoWalletDetails" */ 'components/user/psp/CryptoWallet').then((m) => ({
    default: m.CryptoWalletDetailsRouters,
  })),
);
export const TransactionResultAsync = lazy(
  () => import(/* webpackChunkName: "user-transactionResult" */ 'components/user/psp/transactionResult'),
);
